import { useQuery } from "react-query";
import AllearningsPresenter from "./AllearningsPresenter";
import { ChartYear } from "@arelia-types/earnings";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { DONATION_UPDATE_EVENT_NAME, MERCH_UPDATE_EVENT_NAME, PERFORMANCE_UPDATE_EVENT_NAME } from "../../features/earnings/constants";
import { ComponentProps } from "@arelia-types/widget";
import { http } from "src/api/http";

export default function AllEarningsContainer({ config }: ComponentProps) {
  const emptyData: ChartYear = {
    lastYear: {
      labels: [],
      data: []
    },
    thisYear: {
      labels: [],
      data: [] 
    }
  };

  const { data = emptyData, isLoading, isError, refetch } = useQuery<ChartYear>({
    queryKey: ["chart-year"],
    queryFn: () => http(`/api/earnings/chart-year${config.query ? `?${config.query}` : ''}`)
  });

  useEventListeners([
    DONATION_UPDATE_EVENT_NAME,
    MERCH_UPDATE_EVENT_NAME,
    PERFORMANCE_UPDATE_EVENT_NAME
  ], () => {
    refetch();
  });

  return (
    <AllearningsPresenter
      dataProps={data}
      title={config.name}
      loading={isLoading}
      error={isError}
    />
  );
}